module.exports = __webpack_public_path__ + "img/kvikkleirerapport.d9eabfbb.jpg";